import './App.css';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, BrowserRouter as Router} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './comps/footer';
import Home from './comps/home';
import Page404 from './comps/page404';

function App() {
  useEffect(()=>{
    toast("wellcome to Pixa Search App");
  }, []);
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home}></Route>
        <Route path="/404" component={Page404}></Route>
        <Redirect to="/404"></Redirect>
      </Switch>
      <div>
        <Footer/>
        <ToastContainer/>
      </div>
  </Router>);
}

export default App;
